<input type="text" [attr.class]="cssClass" placeholder="{{placeholder}}" [minDate]="minDate" [maxDate]="maxDate" [bsConfig]="dpConfig" #drp="bsDatepicker"
bsDatepicker (bsValueChange)="onBsValueChange($event)">
